import React, { useState, useRef } from "react";
import { Button } from "@mui/material";

const SlidingPanel = ({
  children,
  buttonLabel,
  cancelLabel,
  resetText,
  onReset,
  disabled,
  buttonClassName,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const contentRef = useRef(null);
  const panelRef = useRef(null);

  const togglePanel = () => {
    setIsOpen(!isOpen);

    // Smooth scroll
    if (panelRef?.current) {
      panelRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="sliding-panel" ref={panelRef}>
      <div
        ref={contentRef}
        className={`sliding-panel-content ${isOpen ? "open" : ""}`}
        style={{
          maxHeight: isOpen
            ? `${contentRef.current?.scrollHeight * 1.2}px`
            : "0px",
        }}
      >
        {children}
      </div>
      <div
        className={`sliding-panel-buttons ${
          isOpen && resetText ? "with-reset" : ""
        }`}
      >
        <Button
          onClick={togglePanel}
          disabled={disabled}
          className={buttonClassName}
        >
          {isOpen ? cancelLabel : buttonLabel}
        </Button>
        {onReset && isOpen && (
          <Button
            onClick={onReset}
            disabled={disabled}
            className={buttonClassName}
            style={{ backgroundColor: "var(--dl-color-theme-neutral-dark)" }}
          >
            {resetText}
          </Button>
        )}
      </div>
    </div>
  );
};

export default SlidingPanel;
